import React, {useEffect, useState} from 'react';
import {Dates, desktopDates} from '../../Store/dates/dates';
import Box from "../../Components/Box/Box";
import Modal from "../../Components/Modal/Modal";

import logo from '../../assets/logo1.png'
import DesktopImage from "../../Components/DesktopImage/DesktopImage";
import {useAuth} from "../../hooks/useAuth";

import {saveVisit, getUserToken, isVoted} from "../../api/requests";

const Home = () => {
    const [modal, setModal] = useState({
        dayId: null,
        isVisible: false
    });
    const {logout} = useAuth();

    const [lastOpenedBox, setLastOpenedBox] = useState(null);

    useEffect(() => {
        if (new Date(Dates[0].day).toLocaleDateString("hu-HU") <= new Date().toLocaleDateString("hu-HU") && new Date().toLocaleDateString("hu-HU") <= new Date(Dates[23].day).toLocaleDateString("hu-HU")) {
            const el = document.getElementById(new Date().getDate().toString());
            if (el) {
                el.scrollIntoView();
            }
        }
    }, []);

    useEffect(() => {
        if (lastOpenedBox !== null) {
            const el = document.getElementById(lastOpenedBox);
            if (el) {
                el.scrollIntoView();
            }
            setLastOpenedBox(null)
        }
    }, [lastOpenedBox]);

    useEffect(()=>{
        const token = localStorage.getItem("token");

        if(!token || token === "null") {
            getUserToken()
                .then((res)=> {
                    localStorage.setItem("token", res.data.token);
                    return saveVisit(modal.dayId);
                });
        }

        if(token) {
            saveVisit(modal.dayId);
        }
    }, [modal])

    return (
        <div className={'adventapp md:bg-main md:bg-cover md:bg-bottom md:bg-no-repeat md:min-h-screen md:flex md:items-center'}>
            <div className="flex flex-col justify-between w-full md:hidden sticky top-0 z-[100]">
                <div className={'flex w-full flex-col p-2 bg-brandPrimary text-white justify-center text-center'}>
                    <img src={logo} alt="" className={'max-w-[100px] mx-auto mb-2'}
                         onClick={() => logout()}/>
                    <h2 className={'italic text-white mb-0 text-md leading-[1.2em]'}>Kellemes karácsonyi ünnepeket kívánunk!</h2>
                </div>
                <div className={'mt-10 flex justify-center'}>
                    <img src="assets/images/nyil.png" alt=""/>
                </div>
            </div>
            <div className={`snap-y snap-mandatory min-h-screen md:hidden ${modal.isVisible && 'hidden'}`}>
                {Dates.map(date =>
                    <div id={new Date(date.day).getDate()} key={date.day}
                         className={"flex flex-col justify-center items-center snap h-screen snap-always snap-center bg-main bg-cover bg-left-bottom"}>
                        <Box date={date.day} image={date.image} setModal={setModal}/>
                    </div>)}
            </div>
            <div className="flex flex-col justify-between sticky w-full md:hidden bottom-0 z-[100]">
                <div className={'mb-10 flex justify-center'}>
                    <img src="assets/images/nyil.png" alt="" className={'rotate-180'}/>
                </div>
                <div className={'flex flex-col w-full justify-center text-center p-2 bg-[#FFF4D1]'}>
                    <span className={'text-brandSecondary italic font-bold'}>Kattints az aktuális dátumra, és nézd meg, mi rejlik mögötte!</span>
                </div>
            </div>
            {modal.isVisible && <Modal day={modal.dayId} setModal={setModal} setLastOpenedBox={setLastOpenedBox}/>}
            <div className="md:max-w-[90vw] lg:max-w-[38vw] 2xl:max-w-[50vw] mx-auto hidden md:block">
                <div className="flex items-center justify-between px-[6%] py-[2%] bg-brandPrimary rounded-t-xl">
                    <div className={'flex flex-col text-white  justify-center'}>
                        <h1 className={'text-2xl lg:text-[1rem] xl:text-2xl 2xl:text-3xl italic text-white font-black'}>Kellemes karácsonyi ünnepeket kívánunk!</h1>
                        <p className="font-bold text-white mb-0 px-1 text-sm lg:text-[0.8rem] xl:text-sm">
                            Decemberben naponta kedveskedünk Neked valamivel. <br/>
                            Készen állsz egy meglepetésre?
                        </p>
                    </div>
                    <img src={logo} alt="" className={'max-w-[25%] cursor-pointer'} onClick={() => logout()}/>
                </div>
                <div className="bg-white px-[6%] py-[3%] pb-0 rounded-b-xl">
                    <div className="grid grid-cols-6 gap-[1.5%]"> {desktopDates.map(date =>
                        <div id={'desktop' + new Date(date.day).getDate()} key={date.day}
                             className={`flex flex-col items-center ${date.colSpan > 1 && 'col-span-2'} ${date.rowSpan > 1 && 'row-span-2'}`}>
                            <DesktopImage date={date} setModal={setModal}/>
                        </div>)}</div>
                    <div className={'py-3 text-center text-brandSecondary font-bold text-sm 2xl:text-base mt-[3%]'}>
                        Kattints az aktuális dátumra, és nézd meg, mi rejlik mögötte!
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;
